import comp from "./ClassSelectionModal";
export default comp;
